var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 105.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 994 c-4 -4 -7 -18 -7 -31 0 -20 5 -23 41 -23 38 0 40 1 37 28 -2 22 -9 28 -33 30 -17 2 -34 0 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 984 c-3 -9 -6 -112 -6 -230 l0 -214 45 0 45 0 0 214 c0 118 -3 221 -6 230 -4 10 -18 16 -39 16 -21 0 -35 -6 -39 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907 994 c-4 -4 -7 -49 -7 -101 l0 -93 40 0 41 0 -3 98 -3 97 -30 3 c-17 2 -34 0 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 743 l3 -118 102 -3 c121 -3 116 -10 111 138 l-3 95 -108 3 -108 3 3 -118z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834 707 c-2 -7 -3 -60 -2 -118 l3 -104 105 0 105 0 0 115 0 115 -103 3 c-79 2 -104 0 -108 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 269 l0 -270 38 3 37 3 3 268 2 267 -40 0 -40 0 0 -271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 340 l0 -120 104 0 c121 0 116 -5 116 120 0 125 5 120 -116 120 l-104 0 0 -120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902 203 l3 -198 38 -3 37 -3 0 200 0 201 -40 0 -40 0 2 -197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482 73 l3 -68 34 -3 c43 -4 51 8 51 81 l0 57 -45 0 -46 0 3 -67z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitcher);
export default __webpack_public_path__ + "static/media/switcher.57c551b53bd112aebacf1e69c0baa9ac.svg";
export { ForwardRef as ReactComponent };